<template>
    <div class="card">
        <div class="card-body">
            <div class="d-md-flex align-items-center">
                <div class="col-md-6 text-left">
                    <h4 class="card-title"><i class="fas fa-paperclip"></i> Attachments</h4>
                </div>
                <div class="col-md-6 text-right">
                    <div class="button-group">
                        <a class="btn btn-success waves-effect waves-light" data-target="#attachmentModal"
                           data-toggle="modal" href="javasript:void(0);">
                            <i class="fas fa-plus"></i> Add New
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="table-responsive" v-if="attachments.length>0">
            <table class="table v-middle">
                <thead>
                <tr class="bg-light">
                    <th class="border-0"><h6>#</h6></th>
                    <th class="border-0"><h6>File Name</h6></th>
                    <th class="border-0"><h6>Title</h6></th>
                    <th class="border-0"><h6>Description</h6></th>
                    <th class="border-0"><h6>Action</h6></th>
                </tr>
                </thead>
                <tbody>
                <tr v-bind:key="index" v-for="(a, index) in attachments">
                    <td>{{index+1}}</td>
                    <td ><a href="javascript:void(0)" @click="downloadFile(a.filename)">{{a.filename}}</a></td>
                    <td>{{a.title}}</td>
                    <td>{{a.desc}}</td>
                    <td class="icon-col">
                        <i @click="getAttachment(a.filename, a.title, a.desc, a.created_at)" class="fas fa-eye m-r-10"
                           data-target="#viewattachmentModal" data-toggle="modal"
                           style="cursor: pointer"></i>
                        <i v-if="status === 'DRAFT'" @click="setRemoveProps(a.id, a.filepath)"
                           class="far fa-trash-alt m-r-10"
                           data-target="#confirmModalForDelAttachment" data-toggle="modal" style="cursor: pointer"></i>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="card-body card-blue" v-else>
            <h4 class="card-title text-muted text-center">No records found</h4>
        </div>
        <!-- MODAL FOR CONFIRMATION -->
        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModalForDelAttachment"
             role="dialog" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body card-blue">
                        <div class="text-center m-t-20 m-b-10">
                            <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                            <br><br>
                            <h4>Are you sure you want to remove this payment term?</h4>
                            <button @click="removeAttachment(docid, filepath)"
                                    class="btn waves-effect waves-light btn-success m-r-15" data-dismiss="modal"
                                    type="button">Yes
                            </button>
                            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL FOR ADDING ATTACHMENT -->
        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="attachmentModal" role="dialog"
             tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <form @submit.prevent="handleSubmit">
                        <div class="modal-header">
                            <h4 class="modal-title" id="attachmentModalLabel">Add Attachment</h4>
                            <button aria-hidden="true" class="close" data-dismiss="modal" type="button">×</button>
                        </div>
                        <div class="modal-body card-blue">
                            <div class="card-body">
                                <div class="form-group row">
                                    <div class="col-sm-12">
                                        <input :class="{'is-invalid': submitted && errors.has('file_title')}"
                                               class="form-control"
                                               id="file_title"
                                               name="file_title"
                                               placeholder="Title"
                                               style="height: 42px;"
                                               type="text"
                                               v-model="fileTitle"
                                               v-validate="'required'">
                                        <div class="invalid-feedback" v-if="submitted && errors.has('file_title')">{{
                                            errors.first('file_title') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-12">
                                                <textarea
                                                        class="form-control"
                                                        data-vv-as="description"
                                                        id="description"
                                                        name="description"
                                                        placeholder="File Description"
                                                        rows=3
                                                        v-model="fileDesc">
                                                </textarea>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="input-group col-md-8">
                                        <div class="custom-file">
                                            <input :class="{'is-invalid': submitted && errors.has('file')}"
                                                   @change="onFileChange"
                                                   class="custom-file-input"
                                                   id="file"
                                                   name="file"
                                                   ref="file"
                                                   type="file"
                                                   v-validate="'required'">
                                            <label class="custom-file-label" for="file" style="cursor: pointer">{{filename}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-success" type="submit">Submit</button>
                            <button @click="resetAttachment" class="btn btn-secondary" type="button">Reset</button>
                            <button class="btn btn-danger" data-dismiss="modal" type="button">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- MODAL FOR VIEW ATTACHMENT -->
        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="viewattachmentModal" role="dialog"
             tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <form>
                        <div class="modal-header">
                            <button aria-hidden="true" class="close" data-dismiss="modal" type="button">×</button>
                        </div>
                        <div class="modal-body card-blue">
                            <div class="card">
                                <img alt="Card image cap" class="card-img-top img-responsive" style="height: 300px"
                                     v-bind:src="imageSrc">
                            </div>
                            <div class="card-body">
                                <div class="d-flex no-block align-items-center m-b-15">
                                    <span><i class="ti-calendar"></i> {{creation_date | date}}</span>
                                </div>
                                <h4 class="card-title">{{title}}</h4>
                                <p class="card-text">{{description}}</p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import axios from 'axios';

    export default {
        name: "MarketplaceContractDocuments",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        props: ["contractid", "status"],
        data() {
            return {
                submitted: false,
                attachments: [],
                docid: null,
                uploadstatus: '',
                file: null,
                filename: "Upload Attachment",
                filepath: null,
                fileTitle: '',
                fileDesc: '',
                contenttype: '',
                imageSrc: null,
                title: null,
                description: null,
                creation_date: null
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/contracts/attachments`, {
                    params: {
                        contractid: this.contractid
                    }
                });
                this.attachments = reply.data;
            },
            setRemoveProps(docid, filepath) {
                this.docid = docid;
                this.filepath = filepath;
            },
            async removeAttachment(docid, filepath) {
                $(".preloader").fadeIn();
                await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/contracts/attachments`, {
                    data: {
                        contractid: this.contractid,
                        docid: docid,
                        filepath: filepath
                    }
                });
                $(".preloader").fadeOut();
                await this.init();
                this.$toastr('success', 'Attachment deleted successfully', 'Success');
            },
            async onFileChange(e) {
                this.file = this.$refs.file.files[0];
                this.filename = this.file.name;
            },
            async handleSubmit() {
                this.submitted = true;
                try {
                    let valid = await this.$validator.validate();
                    if (valid) {
                        this.submitted = false;
                        await this.uploadFile();
                    }
                } catch (e) {
                    console.error(e);
                }
            },
            async uploadFile() {
                this.uploadstatus = "Uploading File Please Wait";
                $(".preloader").fadeIn();
                let signedurl = await this.getUploadUrl();
                await axios.put(signedurl, this.file);
                await this.saveAttachment();
                this.resetAttachment();
                $("#attachmentModal").modal('toggle');
                $(".preloader").fadeOut();
            },
            async getUploadUrl() {
                let signedUrl = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/contracts/signedurl`, {
                    params: {
                        marketplaceid: this.marketplaceid,
                        contractid: this.contractid,
                        name: this.filename,
                        type: 'write'
                    }
                });

                this.filepath = signedUrl.data.key;
                let parts = this.filename.split(".");
                this.contenttype = parts[parts.length - 1];

                return signedUrl.data.url;
            },
            async saveAttachment() {
                let attachment = [{
                    filename: this.filename,
                    title: this.fileTitle,
                    desc: this.fileDesc,
                    filepath: this.filepath,
                    contenttype: this.contenttype
                }];
                await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/contracts/attachments`, attachment, {params: {contractid: this.contractid}});
                await this.init();
            },
            async getAttachment(filename, title, description, creation_date) {
                this.title = title;
                this.description = description;
                this.creation_date = creation_date;
                try {
                    $(".preloader").fadeIn();
                    let result = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/contracts/signedurl`, {
                        params: {
                            contractid: this.contractid,
                            name: filename,
                            type: 'read'
                        }
                    });
                    console.log(result);
                    this.imageSrc = result.data.url;
                    console.log(this.imageSrc);
                    $(".preloader").fadeOut();
                } catch (e) {
                    $(".preloader").fadeOut();
                }
            },
            async downloadFile(_file_name) {
                try {
                    let result = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/contracts/signedurl`, {
                        params: {
                            contractid: this.contractid,
                            name: _file_name,
                            type: 'read'
                        }
                    });
                    this.imageSrc = result.data.url;
                } catch (e) {
                }
                let link = document.createElement('a');
                link.href = this.imageSrc;
                link.download = _file_name;
                link.click();
            },
            resetAttachment() {
                this.file = File;
                this.filename = "Upload Attachment";
                this.fileTitle = null;
                this.fileDesc = null;
                this.filepath = null;
                this.contenttype = null;
            }
        }
    }
</script>

<style scoped>

</style>
